import { IMockSkyBox } from '../babylonjs/type/skyboxType'

export const skyBoxes: IMockSkyBox[] = [
  {
    id: 'Grafiti',
    type: '2d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/512750.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/2dImages/512750.jpg',
    name: 'Grafiti',
    modelIds: ['chairModular', 'middleTable', 'sofa', 'officeChair'],
  },
  {
    id: 'Park',
    type: '2d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/704517.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/2dImages/704517.jpg',
    name: 'Park',
    modelIds: ['chairModular', 'middleTable', 'sofa', 'officeChair'],
  },
  {
    id: 'Stair Art',
    type: '2d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/andy-art-zwZpdhoTbU0-unsplash.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/2dImages/andy-art-zwZpdhoTbU0-unsplash.jpg',
    name: 'Stair Art',
    modelIds: ['chairModular', 'middleTable', 'sofa', 'officeChair'],
  },
  {
    id: 'New York Night',
    type: '2d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/harry-gillen-V7SYr4SSiFg-unsplash.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/2dImages/harry-gillen-V7SYr4SSiFg-unsplash.jpg',
    name: 'New York Night',
  },
  {
    id: 'New York',
    type: '2d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/daryan-shamkhali-tRDGs9utMUo-unsplash.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/2dImages/daryan-shamkhali-tRDGs9utMUo-unsplash.jpg',
    name: 'New York',
  },
  {
    id: 'China Town',
    type: '2d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/haut-risque-cEGI3KqkT5Y-unsplash.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/2dImages/haut-risque-cEGI3KqkT5Y-unsplash.jpg',
    name: 'China Town',
  },
  {
    id: 'Running',
    type: '2d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/jacky-watt-c_PdBxnMKbk-unsplash.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/2dImages/jacky-watt-c_PdBxnMKbk-unsplash.jpg',
    name: 'Running',
  },
  {
    id: 'Beach',
    type: '2d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/mona-jain-2CRHjKXAGdQ-unsplash.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/2dImages/mona-jain-2CRHjKXAGdQ-unsplash.jpg',
    name: 'Beach',
  },
  {
    id: 'Terminal',
    type: '2d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/99-films-d25NfD5ehc0-unsplash.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/2dImages/99-films-d25NfD5ehc0-unsplash.jpg',
    name: 'Terminal',
  },
  {
    id: 'Room',
    type: '2d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/collov-home-design-xJ14RuLV9zI-unsplash.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/2dImages/collov-home-design-xJ14RuLV9zI-unsplash.jpg',
    name: 'Room',
    modelIds: ['chairModular', 'middleTable', 'sofa', 'officeChair'],
  },
  {
    id: 'Sunny',
    type: '3d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/TropicalSunnyDay.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/TropicalSunnyDay/lowRes/TropicalSunnyDay',
    name: 'Sunny',
  },
  {
    id: 'Studio 1',
    type: '3d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/studio.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/hdrFile/studio_small_03_1k.hdr',
    name: 'Studio 1',
    modelIds: ['chairModular', 'middleTable', 'sofa', 'officeChair'],
  },
  {
    id: 'Studio 2',
    type: '3d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/studio.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/studio.env',
    name: 'Studio 2',
  },
  {
    id: 'Parking',
    type: '3d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/DWHA50.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/parking.env',
    name: 'Parking',
  },
  {
    id: 'Institute',
    type: '3d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/blender_institute.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/hdrFile/blender_institute_1k.hdr',
    name: 'Institute',
  },
  {
    id: 'Fireplace',
    type: '3d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/fireplace.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/hdrFile/fireplace_1k.hdr',
    name: 'Fireplace',
  },
  {
    id: 'Kiara',
    type: '3d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/kiara_interior.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/envFile/kiara_interior_4k.dds',
    name: 'Kiara',
    modelIds: ['middleTable'],
  },
  {
    id: 'Lebombo',
    type: '3d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/lebombo.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/envFile/lebombo_4k.dds',
    name: 'Lebombo',
    modelIds: ['sofa'],
  },
  {
    id: 'Museum',
    type: '3d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/museumplein.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/hdrFile/museumplein_1k.hdr',
    name: 'Museum',
  },
  {
    id: 'Palermo',
    type: '3d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/palermo_sidewalk.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/hdrFile/palermo_sidewalk_1k.hdr',
    name: 'Palermo',
  },
  {
    id: 'Sunny Vondel Park',
    type: '3d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/sunny_vondelpark.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/hdrFile/sunny_vondelpark_1k.hdr',
    name: 'Sunny Vondel Park',
  },
  {
    id: 'Urban Alley',
    type: '3d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/urban_alley_01.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/hdrFile/urban_alley_01_1k.hdr',
    name: 'Urban Alley',
  },
  {
    id: 'Comfy Cafe',
    type: '3d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/comfy_cafe.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/envFile/comfy_cafe_4k.dds',
    name: 'Comfy Cafe',
    modelIds: ['chairModular'],
  },
  {
    id: 'Veranda',
    type: '3d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/veranda.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/hdrFile/veranda_1k.hdr',
    name: 'Veranda',
  },
  {
    id: 'Colorful Studio',
    type: '3d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/colorful_studio.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/envFile/colorful_studio_4k.dds',
    name: 'Colorful Studio',
    modelIds: ['chairModular'],
  },
  {
    id: 'Wooden Lounge',
    type: '3d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/wooden_lounge.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/envFile/wooden_lounge_4k.dds',
    name: 'Wooden Lounge',
    modelIds: ['chairModular'],
  },
  {
    id: 'Pano',
    type: '3d',
    previewUrl: '/assets/env/imagesBoxs/pano/pano_nz.jpg',
    path: '/assets/env/imagesBoxs/pano/pano',
    name: 'Pano',
  },
  {
    id: 'Small Empty House',
    type: '3d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/small_empty_house.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/envFile/small_empty_house_4k.dds',
    name: 'Small Empty House',
    modelIds: ['sofa'],
  },
  {
    id: 'Lythwood Room',
    type: '3d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/lythwood_room.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/envFile/lythwood_room_4k.dds',
    name: 'Lythwood Room',
    modelIds: ['middleTable'],
  },
  {
    id: 'Aerodynamics Workshop',
    type: '3d',
    previewUrl:
      'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/preview/aero_dynamics.jpg',
    path: 'https://brikl-poc.s3.ap-southeast-1.amazonaws.com/babylonjs/assets/env/envFile/aerodynamics_workshop_4k.dds',
    name: 'Aerodynamics Workshop',
    modelIds: ['officeChair'],
  },
]
